import React, { forwardRef } from 'react';

import type { FilterPopoverProps } from '@vlabs/monokit/shared/ui/popovers/filter-popover';
import { FilterPopover } from '@vlabs/monokit/shared/ui/popovers/filter-popover';
import validate from '@vlabs/shared/validators';
import { Control } from '@vlabs/uikit';
import { useFormContext } from 'react-hook-form';

import { useSearchPageTranslation } from '../../../../i18n';

function UserDataFilterPopover(
  {
    name = 'user_data',
    ...props
  }: FilterPopoverProps<string>,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { t } = useSearchPageTranslation();
  const { register, formState: { errors } } = useFormContext();

  return (
    <FilterPopover
      {...props}
      name={name}
      ref={ref}
      title={<div className="Body-2">{t('filters.face_filters.user_data')}</div>}
    >
      <Control.Input
        {...register(name, {
          maxLength: validate.maxLength(128),
        })}
        errors={errors}
        id={name}
        isClearable
      />
    </FilterPopover>
  );
}

const UserDataFilterPopoverWithRef = forwardRef(UserDataFilterPopover);
export { UserDataFilterPopoverWithRef as UserDataFilterPopover };
